import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { useMemo } from 'react';
import { headerIconSize, navigationBlockWarningMessage } from 'utils/Global';
import { useNavigationBlock } from './useNavigationBlock';

export interface UseSaveDiscardButtonsParams {
  enableButtons: boolean;
  onSave: (...args) => void;
  onDiscard: (...args) => void;
  saveButtonText?: string;
  discardButtonText?: string;
  alwaysEnableDiscard?: boolean;
  isEditAllowed?: boolean;
  navigationBlockCallback?: (location?: any) => React.ReactNode | string | undefined;
}

export const useSaveDiscardButtons = ({
  enableButtons,
  onSave,
  onDiscard,
  saveButtonText = 'Save',
  discardButtonText = 'Discard',
  alwaysEnableDiscard = false,
  isEditAllowed = true,
  navigationBlockCallback,
}: UseSaveDiscardButtonsParams): RMCustomButtonProps[] => {
  useNavigationBlock(enableButtons, (location) => {
    if (navigationBlockCallback) {
      return navigationBlockCallback(location);
    }
    if (enableButtons) {
      return navigationBlockWarningMessage;
    }
  });
  return useMemo(() => {
    return [
      {
        iconProps: { name: 'Save', fill: '#24A148', ...headerIconSize },
        title: saveButtonText,
        isDisabled: !isEditAllowed || !enableButtons,
        contentOrientation: 'Vertical',
        contentContainerClass: 'header-button-container',
        titleClass: 'header-button-title',
        onClick: onSave,
      },
      {
        iconProps: { name: 'Discard', fill: '#DA1E28', ...headerIconSize },
        title: discardButtonText,
        isDisabled: !alwaysEnableDiscard && !enableButtons,
        contentOrientation: 'Vertical',
        contentContainerClass: 'header-button-container',
        titleClass: 'header-button-title',
        onClick: onDiscard,
      },
    ];
  }, [
    enableButtons,
    onSave,
    onDiscard,
    saveButtonText,
    discardButtonText,
    alwaysEnableDiscard,
    isEditAllowed,
  ]);
};
